module.exports = __webpack_public_path__ + "img/etransfer-white.841ac6bd.svg";